import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { Progress } from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';


import { CarCreationContain } from '../components/CarCreationContain';
//import { TheAccordianCard } from '../components/AccordianCard';
import { InventoryList } from '../components/InventoryList';
import ConfirmationCardBase from '../components/ConfirmationCardBase';
import { DashboardGrid } from '../components/DashboardGrid';
import { DashboardStats } from '../components/DashboardStats';
import DynamicCompContain from '../components/DynamicCompContain';

//add a progress bar at the top
import skull_640 from '../assets/skull_640.png';
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';

//this needs params
const DashBoard = () => {
    const demo_data = [
        {
            label: "Page views",
            stats: "456,578",
            progress: 65,
            color: "teal",
            icon: "up"
        },
        {
            label: "New users",
            stats: "2,550",
            progress: 72,
            color: "blue",
            icon: "up"
        },
        {
            label: "Bids",
            stats: "4,735",
            progress: 52,
            color: "red",
            icon: "down"
        }
    ]

    
    return (
        <>
            <MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            {/*have a switch case for assignment of the sub menu*/}
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <DashboardGrid />
            <br/>
            <br/>
            <br/>
            <DashboardStats data={demo_data}/>
            <br/>
            
            <br/>
            <br/>
            {/*<FooterSimple />*/}
        </>
    )

}

export default DashBoard
